const getMore = {
  "heading": "Not an AT&T customer? <br/> Get more from AT&T.",

  "bodyCopy": "AT&T has the best wireless network according to America’s biggest test.*",
  "cta": {
    "label": "Explore",
    "id": "explore",
    "href": "https://www.att.com/",
    "color": "primary"
  },
  "disclaimer": "*Based on GSW OneScore Sept. 2018. Excludes crowd sourced studies."
}

module.exports = getMore;
